<template>
    <div class="not-found body-card-border-primary">
        <h1>404 - Página No Encontrada</h1>
        <p>Lo sentimos, pero la página que buscas no existe.</p>
        <router-link to="/">Volver</router-link>
    </div>
</template>

<script>
import "@/assets/style.css"

export default {
    name: "NotFound",

    data() {
        return { 
        }
    },

    async created() {
    },

    methods: { },
    
    watch: { },

    computed: { }
}
</script>